(function GoldCardBookings($, Adzuki)
{
	"use strict";

	var $modal = $(".modal");

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/GoldCardBookings/index', function onload()
		{
			$("a.info-link").on('click', function showInfo(e) {
				var id = $(this).data("id");

				e.preventDefault();

				$modal.find('.modal-title').text("Booking details");
				$modal.addClass('wide');

				Adzuki.Ajax.get('/GoldCardBookings/view/' + id)
				.then(function getGoldCardbookingView(content) {
					$modal.find('.modal-body').html(content);
				});

				$modal.modal('show');
			});
		});
	});
}(jQuery, window.Adzuki || {}));
